if (!customElements.get('purchase-notice-drawer')) {
  customElements.define(
    'purchase-notice-drawer',
    class PurchaseNoticeDrawer extends HTMLElement {
      connectedCallback() {
        if (!this.movedToBody) {
          this.movedToBody = true;

          if (this.parentElement !== document.body) {
            document.body.appendChild(this);
            return;
          }
        }

        if (this.initialized) return;

        this.initialized = true;
        this.panel = this.querySelector('.product-purchase-notice-drawer__panel');
        this.closeButtons = this.querySelectorAll('[data-purchase-notice-close]');
        this.boundClose = this.close.bind(this);
        this.boundKeyup = this.onKeyup.bind(this);

        this.closeButtons.forEach((button) => button.addEventListener('click', this.boundClose));
      }

      disconnectedCallback() {
        this.closeButtons?.forEach((button) => button.removeEventListener('click', this.boundClose));
        document.removeEventListener('keyup', this.boundKeyup);
      }

      open(opener) {
        this.opener = opener;
        this.setAttribute('open', '');
        this.setAttribute('aria-hidden', 'false');
        document.body.classList.add('overflow-hidden');
        document.addEventListener('keyup', this.boundKeyup);

        window.requestAnimationFrame(() => {
          if (typeof trapFocus === 'function') {
            trapFocus(this.panel, this.querySelector('.product-purchase-notice-drawer__close') || this.panel);
            return;
          }

          this.panel.focus();
        });
      }

      close() {
        if (!this.hasAttribute('open')) return;

        this.removeAttribute('open');
        this.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('overflow-hidden');
        document.removeEventListener('keyup', this.boundKeyup);

        if (typeof removeTrapFocus === 'function') {
          removeTrapFocus(this.opener);
          return;
        }

        this.opener?.focus();
      }

      onKeyup(event) {
        if (event.code.toUpperCase() !== 'ESCAPE') return;
        this.close();
      }
    }
  );
}

if (!window.purchaseNoticeDrawerBound) {
  window.purchaseNoticeDrawerBound = true;

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-purchase-notice-open]');
    if (!trigger) return;

    const drawerId = trigger.getAttribute('aria-controls');
    const drawer = drawerId ? document.getElementById(drawerId) : null;
    if (!drawer || typeof drawer.open !== 'function') return;

    event.preventDefault();
    drawer.open(trigger);
  });
}
